export default csv => {
  const result = [];
  const rows = csv.trim().split(/\r?\n/);
  const headers = rows[0].split(',').map(h => h.trim());
  for (let i = 1; i < rows.length; i++) {
    const row = rows[i].split(',');
    const obj = {};
    for (let j = 0; j < headers.length; j++) {
      obj[headers[j]] = row[j].trim();
    }
    result.push(obj);
  }
  return result;
};